import React from "react";
import { MessageCircle } from "lucide-react";
import { SITE, DISHES, MORE_MENU } from "@/data/site";
import { Gonjong } from "@/components/Gonjong";

const Menu = () => (
  <main data-testid="menu-page">
    <section className="relative bg-lado-deep text-rice">
      <div className="mx-auto max-w-6xl px-4 pb-20 pt-16 sm:px-6 sm:pt-20">
        <p className="text-sm font-bold uppercase tracking-[0.22em] text-kunyit">
          Menu
        </p>
        <h1
          data-testid="menu-h1"
          className="mt-3 max-w-2xl font-display text-4xl font-black leading-tight sm:text-5xl"
        >
          Menu Masakan Minang RM. Payakumbuah
        </h1>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-rice/85 sm:text-lg">
          Hidangan dimasak otentik dengan beras Solok dan rempah pilihan dari
          ranah Minang. Ini dia yang paling sering jadi incaran.
        </p>
      </div>
      <div className="absolute bottom-0 left-0 right-0 text-rice">
        <Gonjong />
      </div>
    </section>

    <section className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-20">
      <h2 className="font-display text-2xl font-bold sm:text-3xl">Menu Pilihan</h2>
      <div className="mt-10 space-y-14">
        {DISHES.map((dish, i) => (
          <article
            key={dish.name}
            data-testid={`menu-item-${i}`}
            className={`grid items-center gap-8 md:grid-cols-2 ${
              i % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""
            }`}
          >
            <div className="overflow-hidden rounded-2xl border border-ink/10">
              <img
                src={dish.img}
                alt={dish.alt}
                width={dish.w}
                height={dish.h}
                loading="lazy"
                className="h-64 w-full object-cover transition-transform duration-500 hover:scale-105 sm:h-80"
              />
            </div>
            <div>
              <h3 className="font-display text-2xl font-bold text-lado sm:text-3xl">
                {dish.name}
              </h3>
              <p className="mt-3 max-w-md text-base leading-relaxed text-ink/75">
                {dish.desc}
              </p>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-16 rounded-2xl border-2 border-dashed border-ijo/40 bg-ijo/5 p-7 sm:p-9">
        <h2 className="font-display text-2xl font-bold sm:text-3xl">
          Juga tersedia
        </h2>
        <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-testid="menu-more-list">
          {MORE_MENU.map((item) => (
            <li
              key={item}
              className="flex items-center gap-3 text-base font-semibold text-ink"
            >
              <span className="h-2 w-2 rounded-full bg-kunyit" aria-hidden="true" />
              {item}
            </li>
          ))}
        </ul>
        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-ink/70">
          Ketersediaan dan harga menu dapat berbeda di tiap outlet serta kanal
          pemesanan. Untuk daftar menu dan harga terkini, silakan hubungi
          WhatsApp resmi kami atau lihat outlet kami di aplikasi GoFood.
        </p>
        <div className="mt-7 flex flex-wrap gap-4">
          <a
            href={SITE.wa.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="menu-wa-cta"
            className="inline-flex items-center gap-2 rounded-full bg-ijo px-6 py-3 text-base font-bold text-rice transition-transform hover:-translate-y-0.5"
          >
            <MessageCircle className="h-5 w-5" aria-hidden="true" />
            Tanya Menu & Harga
          </a>
          <a
            href={SITE.gofood}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="menu-gofood-cta"
            className="inline-flex items-center gap-2 rounded-full border-2 border-ink/60 px-6 py-3 text-base font-bold text-ink transition-colors hover:border-lado hover:text-lado"
          >
            Pesan di GoFood
          </a>
        </div>
      </div>
    </section>
  </main>
);

export default Menu;
